import { User } from 'lib-shared-types-api';
import pick from 'lodash/pick';
import { createSelector } from 'reselect';

import { AppState } from 'bootstrap.store';

import type { UserModalState } from './userModal.reducer';
import type { UserModalFormData } from './userModal.types';

export function selectUserModal(state: AppState): UserModalState {
  return state.userModal;
}

export function selectUserModalUser(state: AppState): User | null {
  return selectUserModal(state).user;
}

export const selectUserModalInitialValues = createSelector(
  selectUserModalUser,
  (user) => {
    const initialValues: UserModalFormData = {
      ...pick(user, [
        'id',
        'name',
        'given_name',
        'family_name',
        'company_id',
        'avatar_url',
      ] as const satisfies ReadonlyArray<keyof User>),

      emails: user?.email
        ? [
            { value: user.email },
            ...(user.additional_emails?.map((value) => ({ value })) ?? []),
          ]
        : [{ value: '' }],
      phone_numbers: user?.phone_number
        ? [
            { value: user.phone_number },
            ...(user.additional_phone_numbers?.map((value) => ({ value })) ??
              []),
          ]
        : [{ value: '' }],
    };

    initialValues.user_type = user?.type ?? 'contact';

    initialValues.custom_roles = [];

    return initialValues;
  },
);
